var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJoinLeftOuter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.772 11.187A4.73 4.73 0 0 0 10 8a4.73 4.73 0 0 0-1.228-3.187A3.75 3.75 0 0 0 7 8c0 1.345.708 2.525 1.772 3.187"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.127a4.75 4.75 0 1 0 0 7.747 4.75 4.75 0 0 1 0-7.747m.772.686a3.75 3.75 0 1 1 0 6.374q-.348.385-.772.686a4.75 4.75 0 1 0 0-7.747q.424.302.772.687"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJoinLeftOuter);
export default ForwardRef;